import { styled } from '@mui/material/styles';

import {
    Theme,
    containerLargeWidth,
    containerSmallWidth,
    palette,
} from '../../theme';
import { Heading } from '../Heading';
import { HorizontalRule } from '../HorizontalRule';
import { Paragraph } from '../Paragraph';

export const StyledWrapper = styled('div')<{
    $isMBTOptimizationV2orV3?: boolean;
}>`
    max-width: 100%;
    margin: 0 auto;

    ${({ theme }) => theme.breakpoints.up('desktop')} {
        width: 100%;
        max-width: ${containerLargeWidth};
    }

    .pino-option {
        border-radius: ${({ $isMBTOptimizationV2orV3 }) =>
            $isMBTOptimizationV2orV3 && '0'};
    }
`;

export const StyledHeaderSection = styled('div')`
    margin: 0 3rem;

    ${({ theme }) => theme.breakpoints.up('desktop')} {
        margin: 0;
        text-align: center;
    }
`;

export const StyledHeading = styled(Heading)`
    margin-right: 0;
    margin-left: 0;
`;

export const StyledExpanderHeading = styled(Heading)`
    padding: 0 0 0 1.5rem;
    margin-right: 0;
    margin-left: 0;
    font-size: 1.8rem;

    ${({ theme }: { theme: Theme }) => theme.breakpoints.up('desktop')} {
        padding: 0 0 0 3rem;
    }
`;

export const StyledDescription = styled(Paragraph)`
    ${({ theme }: { theme: Theme }) => theme.breakpoints.up('desktop')} {
        max-width: ${containerSmallWidth};
        margin: 0 auto;
    }
`;

export const StyledPanelsWithHeaderWrapper = styled('div')`
    margin-top: ${({ theme }) => theme.spacing(20)};
`;

export const StyledExpanderSection = styled('div')`
    margin-top: 1rem;
`;

export const FullBenefitsWrapper = styled('div')`
    padding-left: 0.8rem;

    ${({ theme }: { theme: Theme }) => theme.breakpoints.up('desktop')} {
        padding-left: 2.3rem;
    }
`;

export const StyledRadioContainer = styled('label')<{
    $checked?: boolean;
    $variant: 'green' | 'blue';
}>`
    position: relative;
    width: 4.2rem;
    height: 4.2rem;
    margin: 2rem 0;
    background-color: ${palette.common.white};
    border: 1px solid ${palette.grey[900]};
    border-radius: 2.25rem;
    input {
        position: absolute;
        width: 4.2rem;
        height: 4.2rem;
        opacity: 0;

        + div {
            padding: 0.5rem;
        }
    }
    svg {
        margin: 0.1rem;
        ${({ $checked }) => $checked && `margin: 0.2rem;`}
    }
`;

export const StyledJoinButtonContainer = styled('div')`
    width: 100%;
    max-width: 34.6rem;
    margin: 3rem auto;
`;

export const StyledFixedMembershipParagraph = styled(Paragraph)`
    padding: 1rem 0 0 3rem;
    ${({ theme }: { theme: Theme }) => theme.breakpoints.up('desktop')} {
        padding: 1rem 20rem 0 20rem;
    }
`;

export const StyledFixedHeading = styled(Heading)`
    padding: 0 0 1rem 0;
    font-size: 1.4rem;
    color: ${({ theme }) => theme.palette.common.blue};
    text-align: center;
    ${({ theme }: { theme: Theme }) => theme.breakpoints.up('desktop')} {
        padding: 4rem 0 1.5rem 0;
        font-size: 1.6rem;
    }
`;

export const StyledPanelsFixedHeader = styled(Heading)`
    padding: 0;
    margin: 0;
    font-size: 1.4rem;
    color: ${({ theme }) => theme.palette.common.blue};
    text-align: center;
    ${({ theme }: { theme: Theme }) => theme.breakpoints.up('desktop')} {
        font-size: 1.6rem;
    }
`;

export const StyledHorizontalRule = styled(HorizontalRule)`
    margin: 3rem 0 2rem 0;
`;

export const StyledHeadContainer = styled('section')`
    padding: 1rem;
    ${({ theme }: { theme: Theme }) => theme.breakpoints.up('desktop')} {
        padding: 1rem 4rem 2rem;
        text-align: center;
    }
`;

export const StyledHeadProductsTitle = styled(Heading)`
    margin-bottom: 2rem;
    font-size: 2.3rem;
    ${({ theme }: { theme: Theme }) => theme.breakpoints.up('desktop')} {
        font-size: 2.6rem;
    }
`;

export const StyledHeadProductsText = styled(Paragraph)`
    margin-bottom: 2rem;
    && {
        font-size: 1.4rem;
    }
`;

export const StyledHeadProductsContainer = styled('div')`
    display: flex;
    gap: 2rem;
    margin-bottom: 2rem;
    ${({ theme }: { theme: Theme }) => theme.breakpoints.up('desktop')} {
        justify-content: center;
    }
`;

export const StyledHeadProductContainer = styled('div')`
    display: flex;
    flex-direction: column;
    ${({ theme }: { theme: Theme }) => theme.breakpoints.up('desktop')} {
        align-items: center;
    }
`;

export const StyledHeadProductDescriptionTile = styled('div')`
    display: flex;
    gap: 0.4rem;
    align-items: center;
    font-size: 1.4rem;
    ${({ theme }: { theme: Theme }) => theme.breakpoints.up('desktop')} {
        justify-content: center;
    }
`;

export const StyledHeadProductHeading = styled('strong')`
    height: 1.5rem;
    font-family: thegymgroupsans-headline;

    ${({ theme }: { theme: Theme }) => theme.breakpoints.up('desktop')} {
        height: 1.6rem;
    }
`;

export const StyledHeadProductText = styled(Paragraph)`
    padding-top: 0.2rem;
    font-size: 1.2rem;
    ${({ theme }: { theme: Theme }) => theme.breakpoints.up('desktop')} {
        max-width: 18rem;
        font-size: 1.4rem;
    }
`;
